import React from 'react';
import { ReactComponent as Logo } from "../../assets/svg/logo.svg";
import styled from 'styled-components';

const Loading = () => {

  return (
    <LoadingBox >
      <Logo width="140" height="40" />
    </LoadingBox>
  );
};

const LoadingBox = styled.div`
  width: 100%;
  height: 100%;
  background-color: #000;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  transition: opacity 1s;

  svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  path {
    fill: transparent;
    stroke: white;
    stroke-width: 1px;
    opacity: 0;
  }

  .t {animation: bounce 0.7s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards 0.1s;}
  .o {animation: bounce 0.7s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards 0.4s;}
  .p1 {animation: bounce 0.7s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards 0.7s;}
  .p2 {animation: bounce 0.7s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards 0.9s;}
  .i {animation: bounce 0.7s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards 1.1s;}
  .n {animation: bounce 0.7s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards 1.3s;}
  .g {animation: bounce 0.7s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards 1.5s;}

  @keyframes bounce {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }
    50% {
      opacity: 1;
      transform: translateY(-20px);
    }
    70% {
      transform: translateY(15px);
    }
    85% {
      transform: translateY(-8px);
    }
    92% {
      transform: translateY(4px);
    }
    100% {
      opacity: 1;
      fill: white;
      transform: translateY(0);
    }
  }
`;

export default Loading;
